import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AnaSayfa from './pages/AnaSayfa';
import Hizmetler from './pages/Hizmetler';
import Hakkimizda from './pages/Hakkimizda';
import Iletisim from './pages/Iletisim';
import Randevu from './pages/Randevu';
import useSEO from './hooks/useSEO';
import './App.css';

function AppContent() {
  useSEO();

  return (
    <div className="App">
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<AnaSayfa />} />
          <Route path="/hizmetler" element={<Hizmetler />} />
          <Route path="/hakkimizda" element={<Hakkimizda />} />
          <Route path="/iletisim" element={<Iletisim />} />
          <Route path="/randevu" element={<Randevu />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
